/* eslint-disable no-undef */
export const getGeolocation = (handleSuccess: PositionCallback, handleFailure: PositionErrorCallback | null, options?: PositionOptions) =>
  navigator.geolocation.getCurrentPosition(handleSuccess, handleFailure, options);

export const geolocationSupported = navigator.geolocation !== undefined;
